//@ts-check
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';

import { isLocal, isProduction } from '../../../utils/environment';
import ErrorBoundary from '../../../utils/react/ErrorBoundary';
import { CartLogic } from './components/CartLogic';

const randomElement = document.createElement('div');
const onError = () => {
  if (isProduction) {
    // ? [REVISIT][PROD] error handling?
  }
};
export const render = () => {
  return ReactDOM.render(
    <StrictMode>
      <ErrorBoundary className="centered-message" key={(!isLocal || new Date()).toString()} onError={onError}>
        <CartLogic />
      </ErrorBoundary>
    </StrictMode>,
    randomElement
  );
};

// HMR
// if (!isProduction && module.hot) {
//   module.hot.accept('./components/CartLogic', () => {
//     const NextApp = require('./components/CartLogic').default;
//     render(NextApp);
//   });
// }
